import { render } from "./StopCard.vue?vue&type=template&id=54befef8&scoped=true"
import script from "./StopCard.vue?vue&type=script&lang=js"
export * from "./StopCard.vue?vue&type=script&lang=js"

import "./StopCard.vue?vue&type=style&index=0&id=54befef8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54befef8"]])

export default __exports__